import { ImportProcDataCheck } from '../../../core/import/process/ImportProcDataCheck';
import { ImportStepFileCheck } from '../../../core/import/definition/ImportStepFileCheck';
import { ImportStepFileSelect } from '../../../core/import/ImportStepFileSelect';
import { ImportStepFileTransform } from '../../../core/import/definition/ImportStepFileTransform';
import { ImportStepMapping } from '../../../core/import/definition/ImportStepMapping';
import * as React from 'react';
import style from '../../../core/import/import_tool.less';
import { WProcess } from '../../../core/process/WProcess';

interface ZusatztoolsImportDefinitionProps extends React.ClassAttributes<any> {
    modul: string;
    IDs: any;
    initData?: any;
    method: string;
    onFinish(): void;
    whitelistStructures?: Array<string>;
}

interface ZusatztoolsImportDefinitionState {
    data: any;
    step: number;
}

export class ZusatztoolsImportDefinition extends React.Component<ZusatztoolsImportDefinitionProps, ZusatztoolsImportDefinitionState> {

    constructor(props: any) {
        super(props);
        this.onDataChange = this.onDataChange.bind(this);
        this.onDone = this.onDone.bind(this);
        this.onStepChange = this.onStepChange.bind(this);
        this.state = {
            data: this.props.initData ? this.props.initData : {},
            step: 0
        };
    }

    private maxStep = 4;

    private onDataChange(data: any): void {
        if (this.state.step === 1) {
            data.structureKey = this.props.initData.structureKey || data.structureKey;
            data.selectedValues = this.props.initData.selectedValues || data.selectedValues;
        } else if (this.state.step === 3) {
            data.ignoreRows = data.ignoreRows || 0;
            data.postProcessSelected = data.postProcessSelected || '';
        }
        if (!data) {
            this.onStepChange(0);
        }
        this.setState({ data });
    }

    private onDone(): void {
        if (this.state.step === this.maxStep) {
            this.props.onFinish();
        } else {
            const step = this.state.step + 1;
            this.setState({ step });
        }
    }

    private onStepChange(step: number): void {
        this.setState({ step });
    }

    render(): JSX.Element {
        return (
            <div className={style.tabMain}>
                <WProcess
                    name='Importprozess'
                    step={this.state.step}
                    onStepChange={this.onStepChange}
                    steps={[
                        {
                            name: 'Excel-Datei hochladen',
                            component:
                                <ImportStepFileSelect
                                    data={this.state.data}
                                    onDataChange={this.onDataChange}
                                    onDone={this.onDone}
                                    cleanDataOnLoad={true}
                                />
                        },
                        {
                            name: 'Dateiformat / Arbeitsblatt',
                            component:
                                <ImportStepFileCheck
                                    data={this.state.data}
                                    onDataChange={this.onDataChange}
                                    onDone={this.onDone}
                                />
                        },
                        {
                            name: 'Kopfzeile / Datenstruktur',
                            component:
                                <ImportStepFileTransform
                                    modul={this.props.modul}
                                    data={this.state.data}
                                    onDataChange={this.onDataChange}
                                    onDone={this.onDone}
                                    hideCreateStructure={true}
                                    whitelistStructures={this.props.whitelistStructures}
                                />
                        },
                        {
                            name: 'Spaltenzuordnung',
                            component:
                                <ImportStepMapping
                                    modul={this.props.modul}
                                    data={this.state.data}
                                    onDataChange={this.onDataChange}
                                    onDone={this.onDone}
                                />
                        },
                        {
                            name: 'Importieren',
                            component:
                                <ImportProcDataCheck
                                    modul={this.props.modul}
                                    IDs={this.props.IDs}
                                    data={this.state.data}
                                    onDataChange={this.onDataChange}
                                    onDone={this.onDone}
                                    onLockChange={() => {}}
                                    simple
                                />
                        }
                    ]}
                 />
            </div>
        );
    }
}
